import { registroCierreSesion } from '../Actions/Usuarios/UsuarioAction';

/**
 * Registra la auditoria de cierre de sesion.
 *
 * Debe esperarse (await) ANTES de limpiar el token del localStorage: si la sesion
 * se limpia primero, la peticion sale sin credenciales y el registro se pierde.
 *
 * El fallo al auditar no se traslada al usuario ni interrumpe el cierre de sesion.
 * Mismo criterio que usp_Gnl_Set_Audit_Log en base de datos.
 *
 * @param {string} userId          Id del usuario que cierra sesion.
 * @param {boolean} cierreAutomatico  true si el cierre lo provoca la inactividad.
 */
export const registraAuditoriaCierreSesion = async (userId, cierreAutomatico) => {
    try {
        const response = await registroCierreSesion(userId, cierreAutomatico);

        if (!response || response.status !== 200) {
            console.error('Problemas al registrar la auditoria de cierre de sesion.', response);
        }
    } catch (e) {
        console.error('Problemas al registrar la auditoria de cierre de sesion.', e);
    }
};
